import { clsx } from 'clsx'
import { forwardRef } from 'react'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

const Select = forwardRef(({ 
  label, 
  error, 
  hint,
  leftIcon: LeftIcon,
  className = '',
  children,
  ...props 
}, ref) => {
  const { isMobileUI, isAdminAppUI } = useLayoutVariant()
  
  return (
    <div className="w-full">
      {label && (
        <label className={clsx(
          'block text-sm font-medium mb-1.5',
          isAdminAppUI ? 'text-[#7a8fa6]' : isMobileUI ? 'text-gray-700' : 'text-gray-700 dark:text-gray-300'
        )}>
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {LeftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10">
            <LeftIcon className={clsx(
              'h-5 w-5',
              isAdminAppUI ? 'text-[#3d5166]' : isMobileUI ? 'text-gray-500' : 'text-gray-500 dark:text-gray-500'
            )} />
          </div>
        )}
        <select
          ref={ref}
          className={clsx(
            'block w-full transition-colors appearance-none',
            isAdminAppUI
              ? 'rounded-[10px] border border-[#243246] bg-[#1f2d40] px-3 py-2.5 pr-9 text-sm text-[#e8edf5] focus:outline-none focus:ring-2 focus:ring-[#00c896]/25 focus:border-[#00c896]'
              : isMobileUI
              ? 'rounded-2xl border-0 bg-gray-50 pl-10 pr-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-500/50'
              : 'rounded-lg border px-3 py-2 text-sm',
            LeftIcon && (isMobileUI ? 'pl-10' : 'pl-10'),
            !isMobileUI && !isAdminAppUI && (
              error
                ? 'border-red-300 dark:border-red-600 text-red-900 dark:text-red-200 focus:border-red-500 dark:focus:border-red-500 focus:ring-red-500 dark:focus:ring-red-500'
                : 'border-gray-300 dark:border-gray-600 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 focus:border-primary-500 dark:focus:border-primary-400 focus:ring-primary-500 dark:focus:ring-primary-400'
            ),
            !isMobileUI && !isAdminAppUI && 'focus:outline-none focus:ring-2 focus:ring-offset-0',
            'disabled:bg-gray-50 dark:disabled:bg-gray-900 disabled:text-gray-500 dark:disabled:text-gray-400 disabled:cursor-not-allowed',
            isAdminAppUI && 'bg-[url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%233d5166\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")] bg-[length:1.5em_1.5em] bg-[right_0.5rem_center] bg-no-repeat',
            !isMobileUI && !isAdminAppUI && 'bg-[url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")] bg-[length:1.5em_1.5em] bg-[right_0.5rem_center] bg-no-repeat',
            !isMobileUI && !isAdminAppUI && 'dark:bg-[url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%9ca3af\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'M6 8l4 4 4-4\'/%3e%3c/svg%3e")]',
            error && isMobileUI && 'ring-2 ring-red-500/50',
            error && isAdminAppUI && 'border-[#ef5350] focus:ring-[#ef5350]/25 focus:border-[#ef5350]',
            className
          )}
          {...props}
        >
          {children}
        </select>
      </div>
      {error && (
        <p className="mt-1.5 text-sm text-red-700 dark:text-red-400">{error}</p>
      )}
      {hint && !error && (
        <p className="mt-1.5 text-sm text-gray-600 dark:text-gray-500">{hint}</p>
      )}
    </div>
  )
})

Select.displayName = 'Select'

export default Select

